export const CHART_INTERVAL_DAILY = 'daily';
export const CHART_INTERVAL_CUMULATIVE = 'cumulative';
